var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading == true
      ? _c(
          "div",
          { staticClass: "text-center pt-4" },
          _vm._l(10, function(option) {
            return _c("div", { staticClass: "row ml-1" }, [
              _c(
                "div",
                {
                  staticClass: "res_heading_1",
                  staticStyle: { "padding-left": "0px" }
                },
                [_c("PuSkeleton", { attrs: { count: 1 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "res_heading_2",
                  staticStyle: { "padding-left": "10px" }
                },
                [_c("PuSkeleton", { attrs: { count: 1 } })],
                1
              ),
              _vm._v(" "),
              _vm._m(0, true)
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.statusUpdateSuccessMsg
      ? _c("div", { staticClass: "text-green" }, [
          _vm._v(_vm._s(_vm.statusUpdateSuccessMsg))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.statusUpdateErrorMsg
      ? _c("div", { staticClass: "text-red" }, [
          _vm._v(_vm._s(_vm.statusUpdateErrorMsg))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loading == false
      ? _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.privileges_selected,
                  expression: "privileges_selected"
                }
              ],
              attrs: {
                type: "checkbox",
                id: "mentee_app_settings",
                value: "1"
              },
              domProps: {
                checked: _vm.privileges_selected,
                checked: Array.isArray(_vm.privileges_selected)
                  ? _vm._i(_vm.privileges_selected, "1") > -1
                  : _vm.privileges_selected
              },
              on: {
                click: function($event) {
                  return _vm.updateSettings($event, "privileges")
                },
                change: function($event) {
                  var $$a = _vm.privileges_selected,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "1",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.privileges_selected = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.privileges_selected = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.privileges_selected = $$c
                  }
                }
              }
            }),
            _vm._v(" \n            "),
            _c("label", { attrs: { for: "mentee_app_settings" } }, [
              _vm._v("Mentees and Apprentices can submit reps for review")
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loading == false
      ? _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.primary_admin_renew_subscription,
                  expression: "primary_admin_renew_subscription"
                }
              ],
              attrs: {
                type: "checkbox",
                id: "primary_admin_settings",
                value: "1"
              },
              domProps: {
                checked: _vm.primary_admin_renew_subscription,
                checked: Array.isArray(_vm.primary_admin_renew_subscription)
                  ? _vm._i(_vm.primary_admin_renew_subscription, "1") > -1
                  : _vm.primary_admin_renew_subscription
              },
              on: {
                click: function($event) {
                  return _vm.updateSettings($event, "renew")
                },
                change: function($event) {
                  var $$a = _vm.primary_admin_renew_subscription,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "1",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        (_vm.primary_admin_renew_subscription = $$a.concat([
                          $$v
                        ]))
                    } else {
                      $$i > -1 &&
                        (_vm.primary_admin_renew_subscription = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.primary_admin_renew_subscription = $$c
                  }
                }
              }
            }),
            _vm._v(" \n            "),
            _c("label", { attrs: { for: "primary_admin_settings" } }, [
              _vm._v("Primary Admin can renew subscription")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 p-0" }, [
      _c("div", { staticClass: "custom_hr" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75506f2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75506f2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/settings_tab.vue
// module id = null
// module chunks = 